import api from '@/plugins/axios'

const base = 'v1/site/link/'

export default {
    getLink(slug) {
        return api.get(base + slug)
    },
}